export default __webpack_public_path__ + "static/media/cards.37bb230d.png";